import ReportViewDetail from "./ReportViewDetail";
import ReportIssueDetail from "./ReportIssueDetail";
import { useState, useEffect } from "react";
import { format } from "date-fns";

function ReportView({ list, form, formStatus, listIssues }) {
  const [issueByLocation, setIssueByLocation] = useState({});

  useEffect(() => {
    if (listIssues && listIssues.length > 0) {
      setIssueByLocation(
        Object.groupBy(listIssues, (issue) => issue.location_id)
      );
    }
  }, [listIssues]);

  const dateRender = () => {
    if (form.start_date && form.end_date) {
      return `${format(new Date(form.start_date), "dd MMMM")} - ${format(
        new Date(form.end_date),
        "dd MMMM yyyy"
      )}`;
    }
    return "";
  };

  return (
    <div>
      {list.map((machine) => {
        return (
          <ReportViewDetail
            key={machine.id}
            machine={machine}
            form={form}
            formStatus={formStatus}
          />
        );
      })}
      {listIssues.length > 0 && (
        <div>
    <div className={"date-right"}>{dateRender()}</div>
          <h5 style={{ fontWeight: "bold", marginTop: "10px", color: "black" }}>
            Issues Report
          </h5>

          {Object.entries(issueByLocation).map(([locationId, issues]) => {
            return (
              <ReportIssueDetail key={locationId} issues={issues} form={form} />
            );
          })}
        </div>
      )}
    </div>
  );
}
export default ReportView;
